import { z } from 'zod';
import { SPORT_IDS } from '../sports/index';

const sportIdEnum = z.enum(SPORT_IDS as [string, ...string[]]);

export const createOrgSchema = z.object({
  name: z.string().min(1).max(100),
  slug: z.string().min(2).max(50).regex(/^[a-z0-9-]+$/).optional(),
  sportTypes: z.array(sportIdEnum).min(1),
  city: z.string().max(100).optional(),
  country: z.string().max(10).optional(),
  // Required: every club must be tied to a city (geocoding, region search, TZ).
  cityId: z.string().min(1).max(100),
  description: z.string().max(1000).optional(),
  timezone: z.string().default('UTC'),
  locale: z.enum(['ru', 'en']).default('ru'),
  // КАК вступают, а не «ищем ли людей» — не путать с recruiting ниже.
  joinMode: z.enum(['open', 'approval']).default('open'),
  // «Ищем игроков» — заявка клуба для фида. Наружу булев тумблер; в срок
  // (recruiting_until = now + RECRUITING_TTL_DAYS) его превращает сервер:
  // политика протухания — не дело клиента.
  recruiting: z.boolean().optional(),
  // Optional admin contacts shown on the club page so members can reach out.
  // Stored in the organizations.contact jsonb column.
  contact: z
    .object({
      telegram: z.string().max(100).optional(),
      phone: z.string().max(50).optional(),
    })
    .nullish(),
});

export const updateOrgSchema = createOrgSchema.partial();

export const joinOrgSchema = z.object({
  inviteCode: z.string().optional(),
  // Optional note from the applicant ("кто/что/зачем") shown to admins with
  // the join request (TG notification + the pending-requests review).
  message: z.string().max(500).optional(),
});
